import { PAY_NOW_RESULT } from "../actions/index";

export default function(state = {}, action) {
  switch (action.type) {
    case PAY_NOW_RESULT:
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Pay.js